import {navigate} from 'gatsby'
import getUrlVars from '../../helpers/getUrlVars'

export default function(){
	console.log(getUrlVars('navigate'))
	if(getUrlVars('navigate') === 'checkout'){
		navigate('/checkout')
	}
}